import React from 'react';
import { Form, Col } from 'react-bootstrap';
import Loadable from '@loadable/component';

import './newsletter.styles.scss';

const Pulse = Loadable(() => import('react-reveal/Pulse'));

const Newsletter: React.FC = () => {
  return (
    <Pulse>
      <div className="newsletter ptb-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="newsletter-image">
                <img
                  src={require('../../assets/photos/newsletter/newsletter.png')}
                  alt="newsletter"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="newsletter-content">
                <h2>Stay up to date with our newsletter</h2>

                <Form
                  className="newsletter-form"
                  action="https://hopintech.us17.list-manage.com/subscribe/post?u=346c00f83faa1c96fbf868736&id=cf095bb3cb"
                  method="post"
                  target="_blank"
                >
                  <Form.Group as={Col} lg="12" md="12">
                    <Form.Control
                      id="mce-EMAIL"
                      className="input-newsletter"
                      name="EMAIL"
                      type="email"
                      placeholder="Enter your email address"
                      required
                    />
                  </Form.Group>
                  <Form.Control
                    hidden
                    type="text"
                    name="b_346c00f83faa1c96fbf868736_cf095bb3cb"
                    tabIndex={-1}
                    value=""
                  />
                  <button type="submit" className="default-btn">
                    <i className="flaticon-tick"></i>
                    Register <span></span>
                  </button>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Pulse>
  );
};

export default Newsletter;
